import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { AppPartName } from "./analyticsTypes";

export function formatProductName(name?: string): string {
  if (name === INSURANCE_NAME_VALUE.NEW_CHILD) {
    return INSURANCE_NAME_VALUE.CHILD.toLocaleLowerCase();
  }
  return name ? name.replace(/[\s\\-_]/g, "").toLocaleLowerCase() : "";
}

export function stepName(step: number | string, appPart?: AppPartName): string {
  const name = typeof step === "string" ? formatProductName(step) : step;
  if (appPart) {
    return `${appPart} ${name}`;
  }
  return `${name}`;
}
